export const isKakaoTalkInAppBrowser = () => /KAKAOTALK/i.test(navigator.userAgent);

export function openKakaoLiveInExternalBrowser(): () => void {
  if (!isKakaoTalkInAppBrowser()) return () => {};

  const externalUrl = `kakaotalk://web/openExternal?url=${encodeURIComponent(window.location.href)}`;
  const deadline = Date.now() + 10000;
  let closeAttempted = false;

  const cleanup = () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.removeEventListener('pagehide', closeInApp);
    window.clearTimeout(expiry);
  };
  const closeInApp = () => {
    if (closeAttempted) return;
    closeAttempted = true;
    cleanup();
    if (Date.now() > deadline) return;
    // These Kakao schemes are unofficial; leaving the page is only a handoff
    // signal, not proof that the external browser opened successfully.
    try { window.location.assign('kakaotalk://inappbrowser/close'); } catch { /* Keep the manual guidance visible. */ }
  };
  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') closeInApp();
  };

  // Register before opening so the close request can run before the webview
  // suspends timers. If opening is blocked, leave the retry screen available.
  document.addEventListener('visibilitychange', onVisibilityChange);
  window.addEventListener('pagehide', closeInApp);
  const expiry = window.setTimeout(cleanup, 10000);
  try { window.location.assign(externalUrl); } catch { cleanup(); }
  return cleanup;
}
